import './FormContainer.scss';
import Component from './FormContainer.js';
export default Component;
